/* eslint-disable ember/no-runloop */
import { later } from '@ember/runloop';
import { modifier } from 'ember-modifier';

const outsideClickHandler = modifier(
  (element: Element, [onClick, selector]: [() => void, string?]) => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handler = (event: MouseEvent) => {
      let isInside = false;

      if (!event.target) {
        return;
      }
      const target = event.target as HTMLElement;

      // If a selector is provided, check if the click was inside the element that matches the selector.
      // Otherwise, check if the click was inside the element that this modifier was applied to.
      if (selector) {
        isInside = target.closest(selector) !== null;
      } else {
        isInside = element.contains(target);
      }

      if (!isInside) {
        onClick();
      }
    };

    // Use `later` because the click event that caused this modifier to run should not be handled by this modifier.
    // The element that triggered the click event will be removed from the DOM by the time this modifier runs.
    later(() => {
      document.addEventListener('click', handler);
    }, 0);

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      document.removeEventListener('click', handler);
    };
  },
);

export default outsideClickHandler;
